<template>
  <div id="wrapper">
    <div id="page-wrapper" class="light-gray-bg dashbard-1" v-if="isMatchPath">
      <!-- MainView -->
      <article @click.self="open = false" :class="{ 'full-column' : !open }" class="wrapper wrapper-content main-column">
        <!-- ViewTitleBox -->
        <div class="ibox-tools view-title">
            <h1 class="info-menu view-name">
                <img src="static/img/assets/nav_1on1_on.png" alt="">
                {{$t('oneRequest')}}
            </h1>
            <span class="info-right">
            </span>
        </div>
        <!-- /ViewTitleBox -->
        <section class="animated fadeInRight">
          <!-- <regist-dest/> -->
          <!-- <regist-text :view="'1on1Request'"/> -->
          <!-- <regist-button :view="'1on1Request'"/> -->
            <div class="ibox-child">
              <div class="row">
                <div class="form-group col-sm-12">
                    <label class="control-label">{{$t('rtfbRegConfigTileType')}}</label>
                    <div class="">
                        <div class="input-group">
                          <span @click="setDetail" class="form-control cursor" value="">
                            <span class="dest-tag" :class="{'dest-active' : destUser}">{{ checkedUsersByUserId.userName }}<i @click="onClickDestReset" class="fa fa-times cursor"></i></span>
                          </span>
                          <!-- <input @focus="setDetail" v-model="checkedUsersByUserId.userName" type="text" class="form-control" value=""> -->
                          <span class="input-group-btn">
                              <button @click="setDetail" type="button" class="btn btn-white add-destination"> +</button>
                          </span>
                        </div>
                        <span v-if="!$v.checkedUsers.required">{{$t('sendDesStr')}}</span>
                    </div>
                </div>
              </div>
            </div>

            <div class="ibox-child">
              <div class="row">
                <div class="form-group col-sm-12">
                  <label class="control-label">{{ $t('commentLabelTitle') }}</label>
                  <textarea v-model="requestSendInfo.contentText" class="form-control" :placeholder="$t('inputCommentStr')" rows="10"></textarea>
                </div>
              </div>
            </div>

            <div class="ibox-child">
              <div class="row okr-regist-btnset">
                <span class ="col-4"><button @click="newRequest" type="button" class="btn btn-success block m-b">{{ $t('senderTitle') }}</button></span>
                <span class ="col-4"><button @click="onClickCancel" type="button" class="btn btn-primary block m-b">{{ $t('cancelStr') }}</button></span>
              </div>
            </div>
      </section>
    </article>

      <!-- DetailView -->
       <div id="detailView" class="sub-column" :class="{ 'sub-active' : open }">
         <div class="close-content"><div @click="open = false" class="close-btn cursor"><i class="fa fa-angle-right"></i></div></div>
        <article class="sub-content-wrap">
          <section class="inner-wrap">
            <div class="s-inner-wrap">
              <div class="ibox-title flex-box fl-between ibox-detail-header">
                <span class="info-menu flex-box">{{$t('rtfbRegConfigTileType')}}</span>
                <span class="info-right"></span>
              </div>
            <!-- Public -->
            <div class="ibox">
              <div class="ib-sub-content">
                  <!-- ユーザー検索ボックス-チェックボックス型 -->
                <div class="tabs-container">
                    <div class="ibox-title search-box">
                      <div class="row">
                          <div class="col-sm-12">
                              <div class="input-group">
                                  <input type="text" v-model="searchText" class="typeahead_2 form-control" :placeholder="$t('searchWithUserNameOrGroupNameStr')">
                              </div>
                          </div>
                      </div>
                    </div>
                      <div class="search-resultview">
                      <!-- <div class="ib-sub-content"> -->
                          <ul v-if="searchText == ''">
                            <li><label>{{$t('checkUserStrType')}}</label></li>
                            <li v-if="getVisitedUsers.length === 0"><label>{{$t('notFoundUserStr')}}</label></li>
                            <div>
                              <li v-for="user in getVisitedUsers" :key="user.id" v-if="user && user.userInfo && user.userId !== getUserId"><label>
                                <input type="radio" v-model="checkedUsers" :value="user.userId" class="checkbox public-check">
                                <span class="search-userimg">
                                  <img v-if="user.userInfo.userIcon" :src="user.userInfo.userIcon" alt="image" class="img-circle">
                                  <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                                </span>
                                <div class="search-userinfo">
                                  <span class="search-username">{{ user.userInfo.userName }}</span>
                                  <span class="search-userdept">{{ user.userInfo.dept }}</span>
                                </div>
                                <span class="check-mark"></span>
                              </label></li>
                            </div>
                          </ul>
                          <ul v-else>
                            <li v-if="Object.keys(this.getUsersBySearchText).length === 0"><label>{{$t('notFoundUserStr')}}</label></li>
                            <div v-for="(user, key) in getUsersBySearchText" :key="user.id" v-if="user && user.userInfo">
                              <li v-if="key !== getUserId"><label>
                                <input type="radio" v-model="checkedUsers" v-bind:value="key" class="checkbox public-check">
                                <span class="search-userimg">
                                  <img v-if="user.userInfo.userIcon" :src="user.userInfo.userIcon" alt="image" class="img-circle">
                                  <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                                </span>
                                <div class="search-userinfo">
                                  <span class="search-username">{{ user.userInfo.userName }}</span>
                                  <span class="search-userdept">{{ user.userInfo.dept }}</span>
                                </div>
                                <span class="check-mark"></span>
                              </label></li>
                            </div>
                          </ul>
                        </div>
                  </div>
                  <!-- /ユーザー検索ボックス-チェックボックス型 -->
              </div>
          </div>
          <!-- /Public  -->
            </div>
          </section>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

function contentTextValidation () {
  return this.requestSendInfo.contentText.trim().replace(/\r?\n/g, '').length !== 0
}

export default {
  name: 'OneRequest',
  mixedins: [validationMixin],
  components: {
  },
  data: function () {
    return {
      tag: 'progress',
      open: false,
      detail: '',
      destUser: false,
      searchText: '',
      checkedUsers: '',
      requestSendInfo: {
        contentText: '',
        createdAt: '',
        userId: '',
        userName: ''
      },
      requestGetObj: {
        requestGetInfo: {
          contentText: '',
          createdAt: '',
          userId: '',
          userName: ''
        },
        sender: ''
      }
    }
  },
  validations: {
    checkedUsers: { required },
    requestSendInfo: {
      contentText: { contentTextValidation }
    }
  },
  computed: {
    isMatchPath () {
      return this.$route.name === 'OneRequest'
    },
    ...mapGetters([
      'getUserId',
      'getCurrentUser',
      'getCurrentUserInfo'
    ]),
    ...mapGetters('users/', [
      'getUsersByText',
      'getUsersByIds',
      'getUserInfoById',
      'getUsers'
    ]),
    ...mapGetters('_meta/', [
      'getMetaIsDeleted'
    ]),
    getVisitedUsers: function () {
      const currentUser = this.getCurrentUser
      console.log('currentUser', currentUser)
      if (currentUser && currentUser.hasOwnProperty('visitHistory')) {
        console.log('in if getVisit')
        // return this.getUsersByIds(Object.keys(currentUser.visitHistory))
        const visitHistory = Object.keys(currentUser.visitHistory || [])
        const recentlyCheckedUsers = this.getUsersByIds(Object.keys(currentUser.visitHistory))
        let sortedRecentlyCheckedUsers = visitHistory.sort((a, b) => { return currentUser.visitHistory[b] - currentUser.visitHistory[a] })
          .filter(key => !this.getMetaIsDeleted(key))
          .map(x => { return recentlyCheckedUsers[x] })
        console.log(sortedRecentlyCheckedUsers)
        return sortedRecentlyCheckedUsers
      } else {
        console.log('in else getVisit')
        return {}
      }
    },
    checkedUsersByUserId: function () {
      if (this.checkedUsers) {
        let userInfo = this.getUserInfoById(this.checkedUsers)
        this.destUser = true
        return userInfo
      } else {
        return ''
      }
    },
    getUsersBySearchText: function () {
      if (this.searchText.length === 0) {
        this.usersForRelation = this.getUsers
        return this.getUsers
      } else {
        this.usersForRelation = this.getUsersByText(this.searchText)
        return this.getUsersByText(this.searchText)
      }
    }
  },
  methods: {
    ...mapActions('ones/', {
      // VuexFireからのActionを読み込み
      setNewSend1on1s: 'SET_NEW_SEND_1ON1S',
      setNewGet1on1s: 'SET_NEW_GET_1ON1S'
    }),
    ...mapActions('peoples', {
      setVisit: 'SET_VISIT_HISTORY'
    }),
    setDetail (value) {
      // console.log('parent methods clear')
      // this.detail = value
      this.open = true
    },
    onClickDestReset: function () {
      this.destUser = ''
      this.checkedUsers = ''
    },
    newRequest: function () {
      this.$swal({
        title: this.$t('send1on1Request'),
        type: 'question',
        showCancelButton: true,
        reverseButtons: false,
        cancelButtonColor: '#f64846',
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-danger',
        animation: false,
        customClass: 'animated fadeInUp',
        // customClass: 'animated flipInX',
        width: '35rem',
        position: 'center',
        // toast: true,
        allowOutsideClick: false,
        padding: '2rem'
        // timer: 4000
      }).then((result) => {
        if (result.value) {
          if (!this.$v.checkedUsers.required) {
            this.$swal({
              title: this.$t('sendDesStr'),
              type: 'warning',
              animation: false,
              customClass: 'animated fadeInUp',
              // customClass: 'animated flipInX',
              width: '35rem',
              position: 'center',
              // toast: true,
              padding: '2rem',
              timer: 3000
            })
          } else if (!this.$v.requestSendInfo.contentText.contentTextValidation) {
            this.$swal({
              title: this.$t('popMessageStrType'),
              type: 'warning',
              animation: false,
              customClass: 'animated fadeInUp',
              // customClass: 'animated flipInX',
              width: '35rem',
              position: 'center',
              // toast: true,
              padding: '2rem',
              timer: 3000
            })
          } else {
            this.requestSendInfo.createdAt = new Date().getTime() / 1000
            this.requestSendInfo.userName = this.checkedUsersByUserId.userName
            this.requestSendInfo.userId = this.checkedUsers
            this.setNewSend1on1s(this.requestSendInfo)

            this.requestGetObj.requestGetInfo.createdAt = this.requestSendInfo.createdAt
            this.requestGetObj.requestGetInfo.contentText = this.requestSendInfo.contentText
            this.requestGetObj.requestGetInfo.userId = this.getUserId
            this.requestGetObj.requestGetInfo.userName = this.getCurrentUserInfo.userName
            this.requestGetObj.sender = this.checkedUsers
            this.setNewGet1on1s(this.requestGetObj)

            this.setVisit(this.checkedUsers)

            this.$swal({
              title: this.$t('popMessageStr5'),
              type: 'success',
              animation: false,
              customClass: 'animated fadeInUp',
              // customClass: 'animated flipInX',
              width: '35rem',
              position: 'center',
              // toast: true,
              padding: '2rem',
              timer: 3000
            })
            this.$router.push('/one/request-sent')
          }
        }
      })
    },
    onClickCancel: function () {
      this.$router.push('/one/request-sent')
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/one/OneRequest.vue